export default {"src":"/_next/static/media/drawing_regular.0ef3dd2f.svg","height":24,"width":24};